import { CreateTenantForm } from "@/features/create-tenant";
import { createFileRoute } from "@tanstack/react-router";
import { isomorphicHttpClient } from "../../../../httpClient";
import { verifyRoles } from "../../../../utils/verifyRoles";

export const Route = createFileRoute("/dashboard/tenants/new/")({
  component: CreateTenantForm,
  head: () => ({
    meta: [
      {
        title: "Novo servidor de autorização - Backoffice Detentora Iniciador",
      },
    ],
  }),
  beforeLoad: () => verifyRoles(["INIC_ADMIN", "ORG_ADMIN"]),
  loader: async ({ context }) => {
    await context.queryClient.prefetchQuery({
      queryKey: ["organizations"],
      queryFn: async () => {
        const httpClient = isomorphicHttpClient();

        const { data, error } = await httpClient.GET("/v1/organizations");

        if (error) {
          throw new Error(error.message);
        }

        return data;
      },
    });
  },
});
